import { Tab } from '@mui/material'
import { APPEARANCE } from './segmentedTabsTokens.js'
import { getSegmentedTabSx } from './getSegmentedTabSx.js'

/** A single segment inside `<SegmentedTabs>`. */
export function SegmentedTab({ sx, iconPosition = 'start', appearance = 'default', ...props }) {
  const tokens = { ...APPEARANCE.default, ...(APPEARANCE[appearance] ?? {}) }

  return (
    <Tab
      disableRipple
      iconPosition={iconPosition}
      sx={[getSegmentedTabSx(tokens), ...(Array.isArray(sx) ? sx : [sx])]}
      {...props}
    />
  )
}
